// components
import { PopoverHint, NumberFormatter } from '@newo/ui-kit';
// icons
import { CircleQuestionMark } from 'lucide-react';
// utils
import { Link } from 'react-router-dom';
import { cn } from '@/utils';

interface StatItemProps {
    title: string;
    hint: React.ReactNode;
    value: number;
    valueClassName?: string;
    prefix?: string;
    to?: string;
}

const StatItem = ({
    title,
    hint,
    value,
    valueClassName,
    prefix,
    to
}: StatItemProps) => {
    const valueContent = <NumberFormatter prefix={prefix} value={value} />;

    return (
        <div className="nw-format-number">
            <div className="text-xs whitespace-nowrap mb-0.5">
                {title}
                <PopoverHint
                    className="text-lg text-gray-6 align-middle ml-2 leading-none print:hidden"
                    hint={hint}
                    trigger={<CircleQuestionMark />}
                />
            </div>
            {to ? (
                <Link
                    className={cn(
                        'text-3xl font-bold no-underline text-current border-0 border-b border-solid border-gray-4',
                        valueClassName
                    )}
                    to={to}
                >
                    {valueContent}
                </Link>
            ) : (
                <div className={cn('text-3xl font-bold', valueClassName)}>
                    {valueContent}
                </div>
            )}
        </div>
    );
};

export default StatItem;
